export default "__VITE_ASSET__BUS4ESSp__"